export default "__VITE_ASSET__10910f04__"